import IconBonus from '@/components/order-processing/order-components/icons/IconBonus'
import IconChild from '@/components/order-processing/order-components/icons/IconChild'
import IconHit from '@/components/order-processing/order-components/icons/IconHit'
import IconSpicy from '@/components/order-processing/order-components/icons/IconHot'
import IconNew from '@/components/order-processing/order-components/icons/IconNew'
import IconPercent from '@/components/order-processing/order-components/icons/IconSale'
import IconPersonalDiscount from '@/components/order-processing/order-components/icons/IconPersonalDiscount'
import IconVegetarian from '@/components/order-processing/order-components/icons/IconVegetarian'

export default {
  components: {
    IconBonus,
    IconChild,
    IconHit,
    IconSpicy,
    IconNew,
    IconPercent,
    IconPersonalDiscount,
    IconVegetarian,
  },
  computed: {
    getLeftSticker () {
      if (this.item.stickerMarketing) {
        return 'icon-' + this.item.stickerMarketing
      }
      return ''
    },
    getRightSticker () {
      if (this.item.stickerType) {
        return 'icon-' + this.item.stickerType
      }
      return ''
    },
  },
}
